function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15636_7129)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15636_7129)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.8271 17.2254H0.15625V0.818115H26.8271V17.2254Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.8271 4.50966H0.15625V2.3562H26.8271V4.50966ZM26.8271 15.7416H0.15625V13.5881H26.8271V15.7416ZM9.21428 6.92909L13.2291 13.069L17.3315 6.95793L9.21428 6.93229V6.92909Z",
  fill: "#0038B8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4743 11.0022L13.2365 12.1398L14.0168 11.0086L12.4707 11.0022H12.4743Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.19922 11.0918L13.2177 4.9519L17.3164 11.0662L9.19922 11.0918Z",
  fill: "#0038B8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4744 6.95793L13.2366 5.82031L14.0169 6.95472L12.4708 6.95793H12.4744ZM10.8772 9.50554L10.0859 10.6592L11.581 10.656L10.8772 9.50234V9.50554ZM10.1005 7.37452L11.6029 7.38413L10.8809 8.54738L10.1005 7.37452ZM15.6141 9.52156L16.3762 10.6592L14.8556 10.6432L15.6141 9.52156ZM16.3617 7.37452L14.8593 7.38413L15.5813 8.54738L16.3617 7.37452ZM12.1936 7.37452L11.158 9.02165L12.2082 10.6335L14.1336 10.672L15.3005 9.02165L14.2211 7.35529L12.1936 7.37131V7.37452Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15636_7129"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15636_7129"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818115)"
})));

function SvgHe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.c4c8fb44.svg";
export { ForwardRef as ReactComponent };